import { ApolloError, ApolloQueryResult } from "@apollo/client";
import {
  BroadcastByUserQuery,
  Exact,
  FilterFindOnePeopleInput,
  FilterFindOneUserInput,
  InputMaybe,
  OperatorsByUserQuery,
  OrganizationsByIdsQuery,
  OrganizationsByUserQuery,
  PersonFindOneNameQuery,
  StorefrontsByUserQuery,
  UserFindOneQuery,
  UserFindSelfQuery,
} from "gql/generated";
import _ from "lodash";
import { createContext, Dispatch, SetStateAction } from "react";

export type NavigationBlockerDetails = {
  isNavigationBlocked: boolean;
  isNavigationBlockerDismissed: boolean;
};

export type AppContextValues = {
  isAuthorized: boolean;
  isInitialized: boolean;
  dbUser: UserFindSelfQuery["userFindOne"];
  dbUserError: boolean;
  dbUserLoading: boolean;
  dbPerson: PersonFindOneNameQuery["personFindOne"];
  dbPersonLoading: boolean;
  operators: OperatorsByUserQuery["operatorsByUser"];
  operatorsError: boolean;
  operatorsLoading: boolean;
  operatorConnections: OrganizationsByIdsQuery["organizationsByIds"];
  operatorConnectionsLoading: boolean;
  operatorConnectionsError: ApolloError | undefined;
  organizations: OrganizationsByUserQuery["organizationsByUser"];
  organizationsError: boolean;
  organizationsLoading: boolean;
  storefronts: StorefrontsByUserQuery["storefrontsByUser"];
  storefrontsEnabled: boolean;
  storefrontsError: boolean;
  storefrontsLoading: boolean;
  navigationBlockerDetails: NavigationBlockerDetails;
  isForcingLogout: boolean;
  refetchDbUser: (
    variables?:
      | Partial<
          Exact<{
            filter?: InputMaybe<FilterFindOneUserInput>;
          }>
        >
      | undefined,
  ) => Promise<ApolloQueryResult<UserFindOneQuery>>;
  refetchDbPerson: (
    variables?:
      | Partial<
          Exact<{
            filter?: InputMaybe<FilterFindOnePeopleInput>;
          }>
        >
      | undefined,
  ) => Promise<ApolloQueryResult<PersonFindOneNameQuery>>;
  setNavigationBlockerDetails: Dispatch<
    SetStateAction<NavigationBlockerDetails>
  >;
  broadcasts: BroadcastByUserQuery["broadcastByUser"];
  broadcastsError: boolean;
  broadcastsLoading: boolean;
  refetchBroadcasts: () => void;
};

export const AppContext = createContext<AppContextValues | null>(null);
